import React, { Component } from 'react';
import PhoneInput from 'react-phone-input-2';
import { isEmpty } from 'lodash';

import LocationAutosuggest from 'components/site/location-autosuggest';
import CargomaticModal from 'components/v2/modal';
import CargomaticInput from 'components/v2/input';
import { Trans, withTranslation } from 'react-i18next';
import { ControlLabel } from 'react-bootstrap';

class OutgateConfirmationModal extends Component {
  constructor() {
    super();
    this.state = {
      name: '',
      address: {},
      suite_or_apt: '',
      contact_name: '',
      contact_phone: '',
    };
  }

  handleInputChange = (field) => (value) => this.setState({ [field]: value });

  handleSave = () => {
    const { address, name, suite_or_apt, contact_name, contact_phone } =
      this.state;

    const payload = {
      completedStopId: this.props.stop._id,
      location: {
        ...address,
        name,
        suite_or_apt,
      },
      contacts: [
        {
          name: contact_name,
          phone: contact_phone,
        },
      ],
    };

    this.props.onSave(payload);
  };

  requiredOutgateModalDetailsProvided = () => {
    const { name, address } = this.state;
    return name && address && !isEmpty(address);
  };

  getModalBody = () => {
    const { t } = this.props;
    return (
      (<div data-testid="div-36853a5f" className="grid grid-cols-4 gap-4">
        <div data-testid="div-c4b79ea1" className="col-span-3">
          <Trans
            i18nKey="NAME_REQUIRED"
            components={[<ControlLabel />, <small data-testid="small-999dc25b" className="text-muted" />]}
          />
          <CargomaticInput
            dataTestId="CargomaticInput-bbc8630c"
            type="text"
            placeholder={t('NAME')}
            onChange={this.handleInputChange('name')} />
        </div>
        <div data-testid="div-97c376a4" className="col-span-2">
          <Trans
            i18nKey="ADDRESS_REQUIRED"
            components={[<ControlLabel />, <small data-testid="small-511625f6" className="text-muted" />]}
          />
          <LocationAutosuggest
            id="address-autosuggest"
            className="mt-1"
            searchField="address"
            callbackSelectedItem={this.handleInputChange('address')}
            placeholderText={t('SEARCH_FOR_ADDRESS')}
          />
        </div>
        <div data-testid="div-9c23f176" className="col-span-2">
          <CargomaticInput
            dataTestId="CargomaticInput-6c485a2b"
            label={t('SUITE_APT')}
            placeholder={t('SUITE_APT')}
            type="text"
            onChange={this.handleInputChange('suite_or_apt')} />
        </div>
        <div data-testid="div-84ed5dc9" className="col-span-2">
          <CargomaticInput
            dataTestId="CargomaticInput-2749226b"
            label={t('CONTACT_NAME')}
            placeholder={t('CONTACT_NAME')}
            type="text"
            onChange={this.handleInputChange('contact_name')} />
        </div>
        <div data-testid="div-0b6469c3" className="col-span-2">
          <label data-testid="label-0665c5af" className="form-label mb-1">{t('CONTACT_PHONE')}</label>
          <PhoneInput
            containerClass="mt-1"
            inputStyle={{ width: '100%' }}
            inputProps=""
            country={COUNTRY_CODE}
            placeholder="555-555-5555"
            value=""
            onChange={this.handleInputChange('contact_phone')}
            id="phone"
          />
        </div>
      </div>)
    );
  };

  getModalFooter = () => {
    const { t } = this.props;
    return (
      (<div data-testid="div-0c0650f6" className="flex justify-end space-x-2">
        <button
          data-testid="button-1d98157c"
          type="button"
          className="button button-secondary"
          onClick={this.props.onCancel}>
          {t('CANCEL')}
        </button>
        <button
          data-testid="button-fc9ac78b"
          type="button"
          className="button button-green"
          onClick={this.handleSave}
          disabled={!this.requiredOutgateModalDetailsProvided()}>
          {t('CONFIRM')}
        </button>
      </div>)
    );
  };

  render() {
    const { t } = this.props;
    return (
      (<CargomaticModal
        dataTestId="CargomaticModal-cb941a11"
        dialogClassName="modal-override-small"
        title={t('ADDITIONAL_STOP_INFO')}
        style={{ top: '30%' }}
        show={this.props.show}
        onHide={this.props.onHide}
        body={this.getModalBody()}
        footer={this.getModalFooter()} />)
    );
  }
}

export default withTranslation()(OutgateConfirmationModal);
